import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { LogOut } from "lucide-react";
import { GymMessageForm } from "./GymMessageForm";
import { useProfile } from "@/hooks/useProfile";

interface GymListProps {
  userGyms: any[];
  onLeaveGym: (gymId?: string) => void;
  currentGymId?: string;
}

export const GymList = ({ userGyms, onLeaveGym, currentGymId }: GymListProps) => {
  const { profile } = useProfile();
  const canSendMessages = profile?.role !== "manager" && profile?.role !== "admin" && profile?.role !== "recepcionista";
  if (!userGyms?.length) return null;

  return (
    <div className="space-y-2">
      <Label>Tus gimnasios</Label>
      <div className="space-y-2">
        {userGyms.map((gym: any) => (
          <div key={gym.id} className="p-4 rounded-lg bg-card border border-border">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <p className="text-foreground">{gym.name}</p>
                {currentGymId === gym.id && (
                  <span className="px-2 py-1 text-xs bg-primary text-primary-foreground rounded-full">
                    Principal
                  </span>
                )}
              </div>
              <AlertDialog>
                <AlertDialogTrigger asChild>
                  <Button variant="destructive" size="sm">
                    <LogOut className="h-4 w-4 mr-2" />
                    Abandonar
                  </Button>
                </AlertDialogTrigger>
                <AlertDialogContent>
                  <AlertDialogHeader>
                    <AlertDialogTitle>¿Estás seguro?</AlertDialogTitle>
                    <AlertDialogDescription>
                      Esta acción no se puede deshacer. Perderás acceso a las clases y servicios del gimnasio {gym.name}.
                    </AlertDialogDescription>
                  </AlertDialogHeader>
                  <AlertDialogFooter>
                    <AlertDialogCancel>Cancelar</AlertDialogCancel>
                    <AlertDialogAction 
                      onClick={() => onLeaveGym(gym.id)} 
                      className="bg-destructive hover:bg-destructive/90"
                    >
                      Abandonar gimnasio
                    </AlertDialogAction>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialog>
            </div>
            {canSendMessages && <GymMessageForm gymId={gym.id} />}
          </div>
        ))}
      </div>
    </div>
  );
};